import { addToChainAfter, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = (
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterWithContent: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        expand: [...(props.apiParameter.expand || []), "content"],
    };
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterWithContent);
